/**
 * 
 *  Example to use component
 * 
 * <CgCheckbox
      options: [
        {
          displayId: "VVQDEUSG57632228",
          name: "Air Abrasion",
          code: "Air Abrasion",
        },
        {
          displayId: "GRBUCPSA80960573",
          name: "3D Imaging System",
          code: "imaging_system",
        },
        {
          displayId: "TPWCZVGW15766362",
          name: "Intra-Oral Camera",
          code: "Intra-Oral Camera",
        },
        {
          displayId: "QEVAENBR19212457",
          name: "CEREC/In-Office Crowns",
          code: "Cad-Cam",
        },
      ],
        keyValues: { label: "name", value: "code" },
         defaultValues: ["Cad-Cam", "Intra-Oral Camera"],
         onSelect={(selected, meta) =>
           console.log("Selected Values:", selected, meta)
         }
         resetValue={resetValues}
         customRenderLabel={() => {
           return (
             <div>
               <h1> Heading</h1>
               <p> Something can be added</p>
             </div>
           );
         }} 
       />
 */

import React, { useState, useEffect } from "react";
import "./cgCheckbox.scss";
const CgCheckbox = ({
  options,
  onSelect = () => {}, // to have multiple Checkbox callback
  disabled = false,
  defaultValues = [],
  customRenderLabel = () => {}, // function
  customLabel = true,
  resetValue,
  name,
  keyValues = { label: "label", value: "value" },
  onChangeCheckbox = () => {}, // induvidual checkbox callback
  renderCustomError, // boolean value
  customErrorMsg, // string
  shouldRenderCheckboxWithBackgroundImageStyle = false, // boolean value
}) => {
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    if (resetValue) {
      setSelectedValues(defaultValues);
    }
  }, [resetValue]);

  useEffect(() => {
    if (defaultValues.length > 0 && selectedValues.length === 0) {
      setSelectedValues(defaultValues);
    }
  }, []);

  const handleChange = (value) => {
    let updatedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    setSelectedValues(updatedValues);

    onSelect(updatedValues);
    onChangeCheckbox(updatedValues);
  };

  return (
    <div
      className={`checkboxWrapper ${disabled ? "disable" : ""} ${
        renderCustomError ? "form-control error" : ""
      } `}
    >
      <div> {customLabel && customRenderLabel()}</div>
      <div
        className={`checkboxItems ${
          shouldRenderCheckboxWithBackgroundImageStyle
            ? "checkbox-background-style"
            : ""
        }`}
      >
        {options.map((optionItem) => (
          <div className="form-check" key={optionItem[keyValues.value]}>
            <input
              className="form-check-input"
              id={name}
              name={name}
              type="checkbox"
              value={optionItem[keyValues.value]}
              checked={selectedValues.includes(optionItem[keyValues.value])}
              defaultValue={selectedValues.includes(
                optionItem[keyValues.value]
              )}
              onChange={() => handleChange(optionItem[keyValues.value])}
              disabled={disabled}
            />
            <label
              className="form-check-label"
              onClick={() => handleChange(optionItem[keyValues.value])}
            >
              {optionItem[keyValues.label]}
            </label>
          </div>
        ))}
      </div>
      {customErrorMsg && (
        <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
      )}
    </div>
  );
};
export default CgCheckbox;
